import { useState, useEffect, useRef } from "react";
import clsx from "clsx";

interface PopupMenuProps {
  trigger: React.ReactNode;
  content: React.ReactNode;
  className?: string;
}

const PopupMenu = ({ trigger, content, className }: PopupMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  const handleOutsideClick = (e: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isOpen]);

  return (
    <div className="relative inline-block">
      <div onClick={() => setIsOpen(!isOpen)}>{trigger}</div>
      {isOpen && (
        <div
          ref={popupRef}
          className={clsx(
            "absolute right-0 mt-2 w-60 bg-background border border-border rounded-md shadow-lg z-50",
            className
          )}
        >
          {content}
        </div>
      )}
    </div>
  );
};

export default PopupMenu;
